import React, { CSSProperties } from 'react'

import CastPath from 'fields/ErrorView/CastPath'
import type { FormikContextType } from 'formik'
import { connect, getIn } from 'formik'
import { get } from 'lodash'

function isString(str) {
  return typeof str === 'string' || str instanceof String
}

function isTouch(props) {
  const touch = getIn(props.formik.touched, props.name)
  if (touch === undefined) {
    const path = CastPath.stringToPath(props.name)
    if (path.length >= 3) {
      const pathArray = path.slice(0, path.length - 2)
      const pathBoolean = path.slice(0, path.length - 1)
      const isArrayValue = Array.isArray(
        get(props.formik.touched, pathArray.join('.'), null),
      )
      if (isArrayValue) {
        return getIn(props.formik.touched, pathBoolean)
      }
    }
  }
  return touch
}

interface ErrorViewProps {
  name: string
  style?: CSSProperties
  formik?: FormikContextType<any>
}

function ErrorView(props: ErrorViewProps) {
  const { name, formik, style } = props

  const error = getIn(formik.errors, name)
  const touch = isTouch(props)
  if (!isString(error)) {
    return <React.Fragment />
  }

  const isShowError = error && touch

  if (!isShowError) {
    return null
  }

  return (
    <div
      id={`error_${name}`}
      style={{ color: 'red', ...(style || { marginTop: isShowError ? 5 : 0 }) }}
    >
      {error}
    </div>
  )
}

export default connect(ErrorView)
